import { Button, message, Popover, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { appUiActions } from "../../../../config/actions/app/appUi.actions";
import { staffRecordsActions } from "../../../../config/actions/administration/staffRecords/staffRecords.actions";
import generatePDF from "../../../../config/services/generatePdf";
import TableTitle from "../../../shared/Tables/TableTitle";
import tableButtonActions from "../../../shared/Tables/TableButtonActions";

const StaffRecordsTable = ({
  handleDeleteStaffRecords,
  handleRefreshTable,
  handleViewDetails,
  handleExportRecords,
}) => {
  /** variable declarations  */
  const [deleteId, setDeleteId] = useState("");
  const [filterTable, setfilterTable] = useState(null);
  const deleteLoading = useSelector(
    (state) => state.staffRecordsState.deleteStaffRecords.loading
  );
  const { loading, data } = useSelector(
    (state) => state.staffRecordsState.staffRecords
  );
  const {
    success: logDetailsSuccess,
    error: logDetailsError,
    records,
  } = useSelector((state) => state.logDetailsState.addLogDetails);

  const dispatch = useDispatch();
  /** functions */
  const search = (value) => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(value.toLowerCase())
      )
    );
    setfilterTable(filterTable);
  };
  const deleteRecord = (e) => setDeleteId(e.target.id);
  const confirmDelete = () => handleDeleteStaffRecords(deleteId);
  const setfilterTableNull = (e) => {
    if (!e.target.value) setfilterTable(null);
  };
  const refreshTable = () => handleRefreshTable();
  const updateRecord = (e) => {
    const updateRecordArray = data.filter((r) => r.id === e.target.id);
    dispatch(staffRecordsActions.setUpdateStaffData(updateRecordArray[0]));
    dispatch(appUiActions.toggleEditStaffRecordsModal(true));
  };
  const showTotal = (total) => `Total: ${total}`;
  const exportRecords = () => {
    message.loading("Processing document for export please wait ", 3);
    handleExportRecords();
  };
  const openAddModal = () =>
    dispatch(appUiActions.toggleAddStaffRecordsModal(true));
  const generateRecordsPdf = () => {
    const pdfColumns = [
      "Name",
      "Gender",
      "Contact",
      "Role",
      "Email",
      "Department",
    ];
    let pdfRows = [];
    data.forEach((record) => {
      const row = [
        `${record.first_name} ${record.other_names}`,
        record.gender,
        record.contact,
        record.role,
        record.email,
        record.department,
      ];
      pdfRows.push(row);
    });
    generatePDF(
      pdfRows,
      pdfColumns,
      `Amani Initiative Staff Records - ${new Date().toLocaleDateString()}`,
      "Amani Initiative Staff Records.pdf"
    );
  };
  useEffect(() => {
    if (logDetailsSuccess && records === "staffRecords") {
      message.info("Started download");
      generateRecordsPdf();
    } else if (!logDetailsSuccess && logDetailsError)
      message.error(logDetailsError);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [logDetailsSuccess, logDetailsError]);
  const viewDetails = (e) => handleViewDetails(e.target.id);
  const columns = [
    {
      title: "First Name",
      key: "name",
      render: (text) => (
        <div>
          <span className="d-md-none">First Name:</span> {text.first_name}{" "}
          <br />
          <div className="d-md-none">
            Other Names: {text.other_names} <br />
            Role: {text.role} <br />
            <Popover
              trigger="click"
              placement="bottom"
              content={() =>
                tableButtonActions(text, {
                  viewDetails,
                  updateRecord,
                  confirmDelete,
                  deleteRecord,
                  deleteLoading,
                  deleteId,
                })
              }
            >
              <Button>Actions</Button>
            </Popover>
          </div>
        </div>
      ),
    },
    {
      title: "Other Names",
      dataIndex: "other_names",
      key: "other_names",
      responsive: ["md"],
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      responsive: ["md"],
    },
    {
      title: "Action",
      key: "operation",
      responsive: ["md"],
      render: (text) => (
        <Popover
          trigger="click"
          placement="bottom"
          content={() =>
            tableButtonActions(text, {
              viewDetails,
              updateRecord,
              confirmDelete,
              deleteRecord,
              deleteLoading,
              deleteId,
            })
          }
        >
          <Button>Actions</Button>
        </Popover>
      ),
    },
  ];

  return (
    <div className="">
      <Table
        pagination={{ total: data.length, showSizeChanger: true, showTotal }}
        loading={loading}
        title={() =>
          TableTitle({
            search,
            setfilterTableNull,
            refreshTable,
            exportRecords,
            openAddModal,
          })
        }
        bordered={true}
        dataSource={filterTable === null ? data : filterTable}
        columns={columns}
      />
    </div>
  );
};

export default StaffRecordsTable;
